import invoiceAutomationImg from "../../../../assets/platform-screenshots/demo/features/invoice-automation.png";
import * as React from 'react';
export default {
  invoiceAutomationImg,
  React
};